import { Component, Input, OnInit } from '@angular/core';
import { PoiListItem } from '../model/list';
import { determineLocale } from 'diwimamodelweb/lib';

@Component({
  selector: 'app-poi-list-item',
  templateUrl: './poi-list-item.component.html',
  styleUrls: ['./poi-list-item.component.css']
})
export class PoiListItemComponent implements OnInit {

  @Input() data: PoiListItem
  locale: string|undefined = undefined

  constructor() {
    this.locale = determineLocale(navigator.language)
  }

  ngOnInit(): void {
  }

  click() {
    this.data.onClick()
  }

  delete() {
    this.data.onDelete()
  }

}
